import React from 'react'

export default function PlatformNumberGridCardLoading() {
  return (
    <div className="relative col-span-10 animate-pulse md:col-span-5 lg:col-span-2">
      <div className="border-muted-300 bg-muted-100 flex h-full flex-col items-center justify-center gap-6 border-2 p-8">
        <div className="bg-muted-300 h-16 w-16 animate-pulse" />
        <div className="flex flex-col items-center gap-2">
          <div className="bg-muted-300 h-4 w-12 animate-pulse" />
          <div className="bg-muted-300 h-4 w-28 animate-pulse" />
        </div>
      </div>
    </div>
  )
}
